import "../../../../src/App.css";
import SlideInOnScroll from "../assets/animations/SlideInScroll";

interface BenefitItem {
  title: string;
  description: string;
}

const benefitItems: BenefitItem[] = [
  {
    title: "Expert AI Chat",
    description: "Get answers to all your hair-related questions",
  },
  {
    title: "Routine Tracker",
    description:
      "Log your hair care routines, receive reminders, track progress",
  },
  {
    title: "Connect",
    description:
      "Discover others with your unique hair type, follow their hair care journey",
  },
];

const BenefitSection = () => {
  return (
    <div className="flex flex-col justify-center items-center lg:mt-[200px] mt-[20px] w-full">
      <div>
        <div className="">
          <SlideInOnScroll id="11" delay={100}>
            <h1 className="text-gray-400 w-[250px]  text-center lg:hidden lg:text-[19px] text-[17px]">
              Know and understand your{" "}
              <span className="font-bold">hair type</span> and its{" "}
              <span className="font-bold">unique</span> caring
            </h1>
          </SlideInOnScroll>
        </div>
      </div>
      <div>
        <div className=" h-full flex w-full items-end justify-center">
          <div>
            <SlideInOnScroll id="22" delay={100}>
              <img
                loading="lazy"
                src="https://ik.imagekit.io/haircareai/whiteHair.png?updatedAt=1719821766122"
                className="h-[200px] md:h-[350px]"
                alt="Logo"
              />
            </SlideInOnScroll>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <SlideInOnScroll id="33" delay={100}>
          <div className="flex items-center lg:mt-16 mt-8 justify-center bg-gray-900 w-[170px] py-4 rounded-full">
            <h1 className="text-white font-semibold text-[17px]">Features</h1>
          </div>
        </SlideInOnScroll>
      </div>
      <div>
        <SlideInOnScroll id="44" delay={100}>
          <h1 className="text-gray-800 ubuntu-sans-h1 text-center pt-4 text-[44px] lg:text-[50px] font-semibold">
            Try Haircare AI
          </h1>
        </SlideInOnScroll>
      </div>
      <div className="mt-[50px] lg:mt-[70px] w-full">
        <div className="flex lg:flex-row flex-col space-y-16 lg:space-y-0 lg:justify-between">
          {benefitItems.map((item, index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center"
            >
              <div>
                <SlideInOnScroll id={`${index}`} delay={100 * index * 2}>
                  <img
                    src="https://ik.imagekit.io/haircareai/phoneMockup.png?updatedAt=1719821762609"
                    className="h-[500px] md:h-[450px]"
                    alt="Logo"
                    loading="lazy"
                  />
                </SlideInOnScroll>
              </div>
              <div className="mt-4">
                <div>
                  <SlideInOnScroll id={`${index + 70}`} delay={100}>
                    <h1 className="text-gray-800 text-center ubuntu-sans-h1 text-[35px] font-semibold">
                      {item.title}
                    </h1>
                  </SlideInOnScroll>
                </div>
                <div>
                  <SlideInOnScroll id={`${index + 80}`} delay={200}>
                    <h1 className="text-gray-400 text-center w-[320px] text-[16px] lg:text-[19px]">
                      {item.description}
                    </h1>
                  </SlideInOnScroll>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="flex h-full lg:pt-5 pt-10 
         w-full items-end  flex-row justify-center"
        >
          <div>
            <SlideInOnScroll id="10" delay={100}>
              <img
                src="https://ik.imagekit.io/haircareai/blackHair.png?updatedAt=1719821765780"
                className="h-[200px] md:h-[350px]"
                alt="Logo"
                loading="lazy"
              />
            </SlideInOnScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitSection;
